import React from 'react';
import { observer } from 'mobx-react-lite';
import { ModalPremiumPlus } from '../modal/premium-plus/modal-premium-plus';

export interface PremiumPlusDialogInterface {
    opened: boolean;
    close: () => void;
    content: React.ReactElement;
    action?: React.ReactElement;
    locked?: boolean;
    width?: number;
}

export const BasePremiumPlusDialog: React.FC<PremiumPlusDialogInterface> = observer(
    ({ width, opened, close, content, locked }) => {
        return (
            <ModalPremiumPlus show={opened} onClose={close} locked={locked} width={width}>
                {content}
            </ModalPremiumPlus>
        );
    },
);
